import {config, ready, onError} from '@umeng/source-sdk';
import Cookies from 'js-cookie';
// source转leads
// sdk说明：https://npm.baijia.com/-/web/detail/@umeng/source-sdk
export default {
    data() {
        return {
            leadsId: '',
        };
    },
    methods: {
        sourceInit(params) {
            const {source, ...otherParams} = params;
            if (process.client) {
                const gid = Cookies.get('GID') || uuid;
                config({
                    sourceId: source,
                    // 区分环境prod // test
                    env: process.env.PATH_TYPE === 'master' ? 'prod' : 'test',
                    // 其他参数会被透传给服务端
                    gid,
                    ...otherParams
                });
                // error handler
                onError(error => {
                    const {message} = error;
                    console.log(message, 'error');
                });
                // 生成leads后 增加哈勃公参，增加sourceLeads全局变量
                ready(leadsId => {
                    this.leadsId = leadsId;
                });
            }
            else {
                console.log('服务端不可调用');
            }
        }
    }
};

